<style scoped lang="scss">
.small-card {
  .box-card {
    margin-bottom: 20px;
    ::v-deep.el-card__header {
      padding: 16px 20px 0 24px;
      border-bottom: 1px solid #f0f0ff;
      div {
        .title {
          font-size: 14px;
          color: #262626;
          font-weight: 600;
        }
        .btns {
          float: right;
        }
      }
    }
  }
}
.datas-container {
  .image-box {
    overflow: hidden;
    zoom: 1;
    margin-right: -12px;
    .item {
      width: 95px;
      height: 95px;
      float: left;
      margin-right: 8px;
      margin-bottom: 10px;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
      .num {
        position: absolute;
        left: 0;
        top: 0;
        width: 16px;
        height: 16px;
        background: rgba(0, 0, 0, 0.25);
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
      }
      .delete {
        position: absolute;
        right: 0;
        top: 0;
        width: 16px;
        height: 16px;
        background: #1890ff;
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
        cursor: pointer;
        opacity: 0;
      }
      .detail {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 16px;
        height: 16px;
        margin: -8px 0 0 -8px;
        background: #1890ff;
        text-align: center;
        line-height: 16px;
        color: #fff;
        font-size: 12px;
        opacity: 0;
        cursor: pointer;
      }
      img {
        width: 95px;
        height: 95px;
      }
      &:hover {
        .delete,
        .detail {
          opacity: 1;
        }
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}
</style>
<template>
  <div>
    <SpCardContent
      title="图片管理"
      class="smallCard"
      :btns="
        disabled
          ? null
          : [
            { key: 'clear', name: '清空', type: 'text' },
            { key: 'edit', name: '编辑图片', type: 'primary' }
          ]
      "
      @btnsOption="managerOperate"
    >
      <div class="meter-text">
        已选择 {{ meters.pics.length }} 张图，最多选择9张图，拖动以排序
      </div>
      <div class="datas-container">
        <div
          v-if="meters"
          class="image-box"
        >
          <draggable
            v-model="meters.pics"
            @start="onStart"
            @end="onEnd"
          >
            <div
              v-for="(item, index) in meters.pics"
              :key="index"
              class="item"
            >
              <span class="num">{{ index + 1 }}</span>
              <img :src="item">
              <span
                v-if="meters.time_type === 3"
                class="delete"
                @click="removePicsImg(index)"
              >X</span>
              <span
                class="detail"
                @click="previewPicsImg(item)"
              ><i
                class="icon1 el-icon-zoom-in"
              /></span>
            </div>
          </draggable>
        </div>
      </div>
    </SpCardContent>
    <!-- 选择图片 -->
    <ImageSelect
      :image-visible="meters.imageVisible"
      @closeImageDialog="closeImageDialog"
      @chooseImage="chooseImage"
    />
    <el-dialog :visible.sync="dialogVisible">
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </div>
</template>

<script>
import ImageSelect from '@/components/imageSelect'
// 第三方组件
import draggable from 'vuedraggable'

export default {
  components: {
    ImageSelect,
    draggable
  },
  props: {
    meters: {
      type: Object,
      default: function () {
        return {}
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialogImageUrl: '', // 预览图地址
      dialogVisible: false //图片预览模态框展示与否
    }
  },
  watch: {
    meters (nVal, oVal) {
      console.log('nVal------->', nVal)
    }
  },
  mounted () {
    console.log('222------>', this.meters)
  },
  methods: {
    managerOperate (key) {
      if (key === 'clear') {
        this.meters.pics = []
      }
      if (key === 'edit') {
        this.meters.imageVisible = true
      }
    },
    closeImageDialog () {
      this.meters.imageVisible = false
    },
    // 选择图片
    chooseImage (selectdata) {
      let selectImageData = []
      selectdata.forEach((v) => {
        selectImageData.push(v.image_url)
      })
      if (this.meters.pics.length + selectImageData.length > 9) {
        if (this.meters.pics.length > 0) {
          this.$message.error(
            '最多添加9张图片,您最多还可以选择' + (9 - this.meters.pics.length) + '张'
          )
        } else {
          this.$message.error('最多添加9张图片,您已经选择了' + selectImageData.length + '张')
        }
      } else {
        this.meters.pics = this.meters.pics.concat(selectImageData)
        this.meters.imageVisible = false
      }
    },
    // 删除图片
    removePicsImg: function (i) {
      this.meters.pics.splice(i, 1)
    },
    // 图片预览
    previewPicsImg (item) {
      this.dialogVisible = true
      this.dialogImageUrl = item
    },

    // 拖拽绑定事件
    onStart (evt) {
      console.log(evt)
    },
    onEnd (evt) {
      console.log(evt)
    }
  }
}
</script>
